<div fxLayout="column" fxFlex>
  <div>
    <mat-toolbar fxLayout>
      <span>Error Uploading XML</span>
      <div fxFlex></div>
      <span class="mat-small">Count: {{listData?.length}}</span>
      <div fxLayout fxLayoutAlign="center center">
        <button mat-icon-button [matTooltip]="'LABEL_DOWNLOAD' | translate" (click)="download()" type="button"
          [disabled]="!authService.hasPermission('can_download_upload_xml')">
          <mat-icon svgIcon="download"></mat-icon>
        </button>
      </div>
    </mat-toolbar>
  </div>

  <div class="overflow-y-auto" *ngIf="!loading.export">
    <table mat-table [dataSource]="listData">      

      <!-- Tag -->
      <ng-container matColumnDef="tagName">
        <th mat-header-cell *matHeaderCellDef> Tag </th>
        <td mat-cell *matCellDef="let element"> {{element.tagName}} </td>
      </ng-container>

      <!-- Data -->
      <ng-container matColumnDef="rowData">
        <th mat-header-cell *matHeaderCellDef> Data </th>
        <td mat-cell *matCellDef="let element"> {{element.rowData}} </td>
      </ng-container>

      <!-- Error Message -->
      <ng-container matColumnDef="errorMessage">
        <th mat-header-cell *matHeaderCellDef> Error Message </th>
        <td mat-cell *matCellDef="let element"> {{element.errorMessage}} </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </div>

  <div *ngIf="loading.export" fxFlex fxLayout="row" fxLayoutAlign="center center">
    <mat-progress-spinner mode="indeterminate"></mat-progress-spinner>
  </div>
</div>